import styled from "styled-components";

export const Background = styled.div`

    width: 100vw;
    min-height: 100vh;

    background-color: var(--color-grey-4);
`

export const StyledGreetings = styled.header`

    padding: 45px 0;
    background-color: var(--color-grey-4);

    border-bottom: 1px solid var(--color-grey-3);

    >div{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
    }

    >div h2{
        color: var(--color-grey-0);
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
    }

    >div p{
        color: var(--color-grey-1);
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
    }
`
export const StyledApplication = styled.section`

    background-color: var(--color-grey-4);
    padding: 37px 0;

    h1{
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;

        color: var(--color-grey-0);
    }

    p{
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;

        color: var(--color-grey-0);
        margin-top: 25px;
    }

    div:first-child{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
`